import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import newsList from '../views/newslist.vue'
import newsContent from '../views/newsContent.vue'
import strateList from '../views/strateList.vue'
import strateContent from '../views/strateContent.vue'
import introList from '../views/introlist.vue'
import introContent from '../views/introContent.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/news/list',
    name: 'newsList',
    component: newsList,
    meta: {
      title: '新闻资讯'
    }
  },
  {
    path: '/news/view',
    name: 'newsView',
    component: newsContent,
    meta: {
      title: '内容详情'
    }
  },
  {
    path: '/strate/list',
    name: 'strateList',
    component: strateList,
    meta: {
      title: '游戏攻略'
    }
  },
  {
    path: '/strate/view',
    name: 'strateView',
    component: strateContent,
    meta: {
      title: '内容详情'
    }
  },
  {
    path: '/intro/list',
    name: 'introList',
    component: introList,
    meta: {
      title: '游戏介绍'
    }
  },
  {
    path: '/intro/view',
    name: 'introView',
    component: introContent,
    meta: {
      title: '内容详情'
    }
  }
]

const router = new VueRouter({
  routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js